import { setIsLoading } from '../../../../../actions/general';
import { callApi } from '../../../../../apiCaller';
import { toastError } from '../../../../../utils';

export const API_ADMIN_USER_SURVEYS = 'user/survey/:surveyId';
export const API_ADMIN_USER_SURVEY_DETAILS = 'user/survey/:surveyId/:id';

export const fetchAdminUserSurveysRequest = (surveyId, setUserSurveys) => (dispatch) => {
     dispatch(setIsLoading(true));
     callApi(API_ADMIN_USER_SURVEYS.replace(':surveyId', surveyId), 'GET')
          .then((response) => {
               if (response.status === 200) {
                    setUserSurveys(response.data);
               } else {
                    toastError(response);
               }
          })
          .finally(() => dispatch(setIsLoading(false)));
};

export const fetchAdminUserSurveyDetailsRequest = (surveyId, id, setUserSurveyDetails) => (dispatch) => {
     dispatch(setIsLoading(true));
     callApi(API_ADMIN_USER_SURVEY_DETAILS.replace(':surveyId', surveyId).replace(':id', id), 'GET')
          .then((response) => {
               if (response.status === 200) {
                    setUserSurveyDetails(response.data);
               } else {
                    toastError(response);
               }
          })
          .finally(() => dispatch(setIsLoading(false)));
};
